// Module
var code = "<div ng-class=\"{'is-disabled': !row.enableSelection}\">\n    <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" ui-grid-cell></div>\n</div>";
// Exports
module.exports = code;